<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <div class="row justify-content-md-center">
        <div class="col-xxl-6 col-xl-6 col-lg-8 col-md-8">
          <div class="repAdmin-card">
            <div class="repAdmin-head text-center">
              <div class="repAdmin-head-content">
                <h1>Rep Administrators</h1>
              <div class="admin-list-add">
                <custom-button
                  v-if="addBtn && isEnrollPrime"
                  iconClass="fas fa-plus "
                  className="repAdmin-btn  "
                  title="Add Rep"
                  @onClicked="$bvModal.show('addRep')"
                />

                <custom-button
                  v-if="addBtn && !isEnrollPrime"
                  iconClass="fas fa-plus "
                  className="repAdmin-btn  "
                  title="Add Nuera Rep"
                  @onClicked="$bvModal.show('addRepNuera')"
                />
                
               </div>



              </div>
              

              <p>
                Rep Admins are additional accounts that you can add, that will
                have access to your dashboard.
              </p>
            </div>
            <div class="repAdmin-body">
              <h3>Users</h3>
              <rep-admin-list-content
                :reps="activeReps"
                type="all"
                @onSuccess="getAll"
                 @emailSelected="handleEmailSelection"
              />
              <hr />
              <h3>Pending Users</h3>
              <rep-admin-list-content
                :reps="pendingReps"
                type="pending"
                @onSuccess="getAll"
              />
            </div>
            <rep-admin-add 
              v-if="isEnrollPrime"
              @onSuccess="getAll"
              

    />
            <rep-admin-add-nuera
              v-if="! isEnrollPrime"
              @onSuccess="getAll"
              @onCloseModal="$bvModal.hide('addRepNuera')"
                   

            />
            <enable-email-modal   :email="selectedEmail" 
        @onSubmit="handleSubmit"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import isEnrollPrimeUtil from '@/utils/isEnrollPrimeUtil';


import Api from "@/resource/Api";
import RepAdminAdd from "./RepAdminAdd.vue";
import RepAdminListContent from "./partials/RepAdminListContent.vue";
import RepAdminAddNuera from "./Nuera/RepAdminAddNuera.vue";
import EnableEmailModal from "./EnableEmailModal.vue";
export default {
  name: "RepAdminList",
  components: { RepAdminAdd, RepAdminListContent, EnableEmailModal, RepAdminAddNuera },
  data: () => ({
    activeReps: [],
    pendingReps: [],
    selectedEmail: null,       
    addBtn: false,
    breadcrumbItems: [{ title: "Rep Administrators", active: true }],
  }),
  methods: {
    handleEmailSelection(email) {
      this.selectedEmail = email; 
      this.$bvModal.show("ccEmail"); 
    },
    updateDomainStatus(domainName, status) {
      const domain = this.domains.find(d => d.email_domain === domainName);
      if (domain) {
        domain.cc_status = status; 
      }
    },
    handleSubmit(payload) {
      const url = `v2/update-email-cc`;
      let loader = this.$loading.show();
      Api.post(url, payload)
        .then((res) => {
          this.$notify(res.data.message); 
          this.$bvModal.hide("ccEmail");
        })
        .catch((err) => {
          this.$notify(err.response.data.message, "error"); 
        })
        .finally(() => {

          loader.hide();
         
        });
    },

    getAll() {
      const url = `v2/get-reps-admin-details`;
      let loader = this.$loading.show();
      Api.get(url)
        .then((res) => {
          let data = res.data.data;
          this.addBtn = data.show_add_user_button;
          this.activeReps = data.user_list;
          this.pendingReps = data.pending_user_list;
        })
        .catch(() => {
          this.addBtn = false;
          this.activeReps = [];
          this.pendingReps = [];
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  created() {
    this.getAll();
  },

  computed:{
        isEnrollPrime() {
      return isEnrollPrimeUtil.isEnrollPrime();
    },
  }
};
</script>
<style>
.admin-list-add .repAdmin-btn .fa-plus::before{
  background: transparent !important;
}
.repAdmin-head-content{
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
<style src="@/assets/css/repadmin.css"></style>